var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTagCircle = function SvgTagCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    accessibilityRole: "image"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#037DD6",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4311 13.4951L22.432 13.4961C23.8565 14.9149 23.8551 17.2167 22.433 18.6257L22.4311 18.6275L18.6286 22.4354C18.6284 22.4356 18.6283 22.4357 18.6281 22.4358C17.2025 23.8554 14.9026 23.8539 13.487 22.4364L9.56228 18.5061C8.84004 17.7828 8.45807 16.7835 8.50366 15.7591C8.50367 15.7588 8.50368 15.7586 8.50369 15.7583L8.7115 11.423C8.71151 11.4228 8.71152 11.4226 8.71153 11.4224C8.78557 9.9523 9.95772 8.77966 11.4316 8.71325L11.4316 8.71325L11.4331 8.71318L15.7651 8.50495L15.7651 8.50495L15.7672 8.50484C16.7846 8.45162 17.782 8.83949 18.5063 9.56481L22.4311 13.4951ZM10.8398 13.8359C10.8398 15.4909 12.1807 16.8346 13.835 16.8346C15.4894 16.8346 16.8302 15.4909 16.8302 13.8359C16.8302 12.1809 15.4894 10.8372 13.835 10.8372C12.1807 10.8372 10.8398 12.1809 10.8398 13.8359Z",
    fill: "#0376C9",
    stroke: "#0376C9"
  })));
};
export default SvgTagCircle;